import { Controller } from "@hotwired/stimulus"
import GLightbox from "glightbox"
import "glightbox/dist/css/glightbox.css"

// Wraps a group of <a class="glightbox" href="full-image.jpg"> links (or any
// selector) into a click-to-open image gallery modal with prev/next
// navigation. Usage: data-controller="lightbox-gallery" on a container that
// holds the links (each with the SAME data-gallery value to group them into
// one lightbox with next/prev navigation across all images).
export default class extends Controller {
  connect() {
    this.lightbox = GLightbox({
      selector: this.element.dataset.lightboxGallerySelectorValue || ".glightbox",
      // Without this, GLightbox forces every slide's container to its own
      // fixed default (900x506px) regardless of the actual image's real
      // dimensions — the <img> itself sizes correctly to its own aspect
      // ratio (GLightbox's own CSS already handles that), but the
      // surrounding container stays at the fixed size, leaving visible
      // empty space around images that don't happen to match that exact
      // aspect ratio. 'auto' lets the container shrink to fit its content
      // instead. Confirmed via GLightbox's own source: non-numeric size
      // values are passed through as literal CSS instead of being
      // converted to a pixel value.
      width: "auto",
      height: "auto"
    })
  }

  disconnect() {
    // GLightbox builds its own overlay/modal DOM outside this element and
    // registers document-level listeners — must be destroyed explicitly on
    // every Turbo page visit, same reasoning as select2/DataTables.
    this.lightbox?.destroy()
  }
}
